import { User } from "../models/Layout/User/User";
import { Action } from "./index";
// import { filteredAgentsList } from './WorkersFilters';

const SET_USER = "SET_USER";

const initialState: AuthState = {
  user: null,
};

export interface AuthState {
  user: User | null;
}

export class AuthActions {
  static setUser = (user: User): Action => ({
    type: SET_USER,
    payload: user,
  });
}

export function reduce(
  state: AuthState = initialState,
  action: Action
): AuthState {
  switch (action.type) {
    case SET_USER:
      return { ...state, user: action.payload as User };
    default:
      return state;
  }
}
